/** 逻辑 field key：白名单与请求/速率限速（不含 Token 总量 / 输入输出配额） */
export const MS_OTHER_FIELD_KEYS = {
  allowedClientCIDRs: 'ms.allowedClientCIDRs',
  allowedClientIPs: 'ms.allowedClientIPs',
  requests: 'ms.requests',
  inputTokensValue: 'ms.inputTokensValue',
  inputTokensWindowSeconds: 'ms.inputTokensWindowSeconds',
  outputTokensValue: 'ms.outputTokensValue',
  outputTokensWindowSeconds: 'ms.outputTokensWindowSeconds',
  showRequests: 'ms.showRequests',
  showInputTokens: 'ms.showInputTokens',
  showOutputTokens: 'ms.showOutputTokens',
} as const;

export const MS_OTHER_FIELD_KEY_LIST = [
  MS_OTHER_FIELD_KEYS.allowedClientCIDRs,
  MS_OTHER_FIELD_KEYS.allowedClientIPs,
  MS_OTHER_FIELD_KEYS.requests,
  MS_OTHER_FIELD_KEYS.inputTokensValue,
  MS_OTHER_FIELD_KEYS.inputTokensWindowSeconds,
  MS_OTHER_FIELD_KEYS.outputTokensValue,
  MS_OTHER_FIELD_KEYS.outputTokensWindowSeconds,
  MS_OTHER_FIELD_KEYS.showRequests,
  MS_OTHER_FIELD_KEYS.showInputTokens,
  MS_OTHER_FIELD_KEYS.showOutputTokens,
] as const;
